import { BooleanStore, DummyStore } from 'stores';

import { CampaignLinks } from '../../shared/types';

export const campaignLinksStore = new DummyStore<CampaignLinks>();
export const campaignLinksFiltersStore = new DummyStore<FiltersType>();
export const copiedLinkStore = new DummyStore<string>('');
export const hasOrganizerLinksStore = new BooleanStore(false);
